(function (f) {
    'use strict';

    'function' === typeof define && define.amd ? define(['exports'], f) : 'undefined' !== typeof module && module.exports ? module.exports = f() : f();

})(function () {

    // UTILS
    const root = {};

    function getDataAttr(elem, name) {
        const value = elem.getAttribute('data-' + name);
        const num = parseFloat(value);
        return !isNaN(num) ? num : value;
    }

    function setDataAttr(elem, name, value) {
        elem.setAttribute('data-' + name, value);
    }

    function nameToDashed(name) {
        const arr = name.match(/[0-9A-Z]+[0-9a-z]+/g);
        return (name.match(/[0-9a-z]+/)[0] + (arr ? '-' + arr.join('-') : '')).toLowerCase()
    }

    root.setData = (elem, name, value, write) => {
        elem.data = elem.data || {};
        if (typeof value === 'undefined') {
            delete elem.data[name];
            if (write)
                setDataAttr(elem, nameToDashed(name), '');
            return value;
        }
        elem.data[name] = value;
        if (write)
            setDataAttr(elem, nameToDashed(name), value);
        return value;
    }

    root.getData = (elem, name) => {
        elem.data = elem.data || {};
        if (typeof elem.data[name] === 'undefined')
            root.setData(elem, name, getDataAttr(elem, nameToDashed(name)));
        return elem.data[name];
    }

    return root;

});


// WEBPACK FOOTER //
// ./js/utils/data.js